import { jdiColorFetch } from "../colorFetchV2";

export const getCart = async (requestData: any) => {
  const res = await jdiColorFetch(`trade_cart_get`, {
    method: "get",
    bodyQuery: requestData,
  })
  return res;
};

export const getPageAllData = async (requestData: any) => {
  const res = await jdiColorFetch(`guide_homepage_getPageAllData`, {
    method: "get",
    bodyQuery: requestData,
  })
  return res;
};

export const cms_rootCateListAll = async (requestData: any) => {
  const res = await jdiColorFetch(`guide_catalog_getRootCates`, {
    method: "get",
    bodyQuery: requestData,
    next: { revalidate: 10 },
  })
  return res;
};

export const getHotWordsApi = async (requestData: any) => {
  const res = await jdiColorFetch(`guide_search_getHotWords`, {
    method: "get",
    bodyQuery: requestData,
  })
  return res;
};

export const getSuggestWordsApi = async (requestData: any) => {
  const res = await jdiColorFetch(`guide_search_getSuggestWords`, {
    method: "get",
    bodyQuery: requestData,
  })
  return res;
};
